import React, { useState, useEffect, useContext } from 'react';
import { PeopleContext } from './context/PeopleContex';
import { UserContext } from './context/UserContext';
import AddForm from './AddForm/AddForm';
import { findUniqueTags, tagActivity } from './filterFunction';
import './App.css';
import DisplayData from './DisplayData';

function DataBase() {
  const { peopleData } = useContext(PeopleContext);
  const { signOut } = useContext(UserContext);
  const [filterData, setFilterData] = useState(peopleData);
  const [people, setPeople] = useState(peopleData);
  const [uniqueTags, setUniqueTags] = useState(findUniqueTags(people));
  const [isActive, setisActive] = useState(() => tagActivity(uniqueTags));

  useEffect(() => {
    setFilterData(peopleData);
    setPeople(peopleData);
  }, [peopleData]);

  useEffect(() => {
    setisActive(() => tagActivity(uniqueTags));
  }, [uniqueTags]);

  useEffect(() => {
    setUniqueTags(findUniqueTags(people));
    setFilterData(people);
  }, [people]);

  function filtrData(event, elem) {
    const value = isActive[elem]; //add class "active" to css
    const newIsActive = { ...isActive, [elem]: !value };
    setisActive(newIsActive); //create object with tags state
    const targetTags = Object.entries(newIsActive)
      .filter((elem) => elem[1] === true)
      .map((elem) => elem[0]); // return array with clicked tags
    setFilterData(
      people.filter((x) => targetTags.every((y) => x.tags.includes(y)))
    );
  }

  return (
    <>
      <header>
        <h1>Data:</h1>
      </header>

      <nav>
        <button onClick={() => signOut()}>Sign out</button>
        <div className={'tagsContainer'}>
          {uniqueTags.map((elem, index) => (
            <a
              href="#"
              key={index}
              alt={`${elem}`}
              className={isActive[elem] === true ? 'active tag' : 'tag'}
              onClick={(event) => filtrData(event, elem)}
            >
              {elem}
            </a>
          ))}
        </div>
      </nav>
      <main>
        <DisplayData dataToDisplay={filterData} />
        <AddForm people={people} />
      </main>
    </>
  );
}

export default DataBase;
